import React, { useEffect, useState } from "react";
import {
  Form,
  Input,
  Button,
  Row,
  Col,
  message,
  Radio,
  Select,
  Alert,
  notification,
  Typography,
} from "antd";
import Axios from "axios";
import {
  HomeTwoTone,
  SettingTwoTone,
  SmileOutlined,
  SyncOutlined,
  LoadingOutlined,
  ArrowLeftOutlined,
  SmileTwoTone,
} from "@ant-design/icons";
import {
  BrowserRouter as Router,
  Route,
  Link,
  Switch,
  useNavigate,
  useParams,
  useLocation,
} from "react-router-dom";
import {
  environmentVariable,
  environment,
  apiRoutes,
} from "../../auth/apiRoute";
import LoadingFrame from "../../layout/loadingFrame";
const gutterLayout = { xs: 8, sm: 16, md: 24, lg: 32 };
const layout = {
  wrapperCol: {
    span: 24,
  },
};
const validateMessages = {
  required: "${label} is required!",
  types: {
    email: "${label} is not a valid email!",
    number: "${label} is not a valid number!",
  },
  number: {
    range: "${label} must be between ${min} and ${max}",
  },
};
export default function Editnomination(props) {
  const { Text } = Typography;
  const { Option } = Select;
  const { TextArea } = Input;
  const [form] = Form.useForm();
  const [user, setUser] = useState({});
  const { state } = useLocation();
  const [loading, setLoading] = useState(false);
  const [selectedHotel, setSelectedHotel] = useState();
  const [currentNomination, setCurrentNomination] = useState({});
  const [nominationNavigation, setNominationNavigation] = useState({});
  const [users, setUsers] = useState([]);
  const [nominationsData, setNominations] = useState([]);
  let { nominationId } = useParams();
  let navigate = useNavigate();
  const [hotels, setHotels] = useState([]);
  const categories = [
    "Full-Time Hourly With Guest Contact",
    "Full-Time Hourly Without Guest Contact",
    "Full-Time Room Attendant",
    "Managerial Below General Manager",
  ];
  const questions = [
    "1. Describe the employee’s overall job performance and dedication to his/her profession and to your Hotel. Please be specific and cite at least one example.",
    "2.  Describe the interaction of the employee with his/her coworkers and/or with guests. Please cite specific examples of the employee’s positive impact on the guest experience at your hotel. ",

    "3. Please list any awards or recognition that the employee has received from the Hotel, management, guests, award organizations and/or peers.",
    "4. Please list any other reasons for nominating this employee for the Big Apple Stars Awards.",
  ];

  useEffect(() => {
    checkIfAdmin();
    // getUser();
    getMembers();
    getNominationById(nominationId);
    if (!state || !state.nominations) {
      getNominationNavigation(nominationId);
    }
    getHotels();
  }, [nominationId]);

  useEffect(() => {
    if (currentNomination && currentNomination.user) {
      form.setFieldValue("user", currentNomination.user._id);
    }
  }, [users, currentNomination]);
  const getMembers = async () => {
    try {
      const response = await Axios.post(apiRoutes[environment].allmembers);

      if (response.status == 200) {
        var members = response.data;
        members = members.map((item) => {
          return { ...item, ...{ key: item._id } };
        });

        setUsers(members);
      }
    } catch (error) {
      if (error.response) {
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
        message.error({
          content: "Sorry, there was an error. " + error.response.data.message,
          className: "messageBox",
        });
      }
    }
  };
  const getHotels = async () => {
    try {
      const response = await Axios.post(apiRoutes["admin/hotels"]);

      if (response.status == 200) {
        var hotelsData = response.data;
        hotelsData = hotelsData.map((item) => {
          return { ...item, ...{ key: item._id } };
        });
        hotelsData.push({
          _id: "00000",
          name: "No Hotel",
        });

        setHotels(hotelsData);
      }
    } catch (error) {
      if (error.response) {
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
        message.error({
          content: "Sorry, there was an error. " + error.response.data.message,
          className: "messageBox",
        });
      }
    }
  };
  const checkIfAdmin = async () => {
    if (!props.user.roles.includes("admin")) {
      navigate("/");
    }
  };

  const getNominations = async () => {
    console.log("get nominations");
    try {
      const response = await Axios.post(apiRoutes[environment].nominations);

      if (response.status == 200) {
        var nominations = response.data;
        nominations = nominations
          .map((item) => {
            return { ...item, ...{ key: item._id } };
          })
          .filter((item) => item.term == new Date().getFullYear());
        setNominations(nominations);
      }
    } catch (error) {
      if (error.response) {
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
        message.error({
          content: "Sorry, there was an error. " + error.response.data.message,
          className: "messageBox",
        });
      }
    }
  };
  const getNominationById = async (nominationId) => {
    setLoading(true);
    try {
      const response = await Axios.post(apiRoutes[environment].getnomination, {
        nominationId: nominationId,
      });

      if (response.status == 200) {
        console.log(response.data);
        setCurrentNomination(response.data);
        if (response.data.hotel) {
          // setHotels([response.data.hotel]);
        }

        form.setFieldsValue(response.data);
        form.setFieldsValue({ hotel: response.data.hotel._id });

        setSelectedHotel(response.data.hotel);
      }
    } catch (error) {
      if (error.response) {
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
        message.error({
          content: "Sorry, there was an error. " + error.response.data.message,
          className: "messageBox",
        });
      }
    }
    setLoading(false);
  };
  const getNominationNavigation = async (nominationId) => {
    try {
      const response = await Axios.post(
        apiRoutes[environment].nominationsNavigation,
        {
          nominationId,
          ...(state && state.nominationNavigation
            ? state.nominationNavigation
            : {}),
        },
      );

      if (response.status == 200) {
        setNominationNavigation(response.data);
      }
    } catch (error) {
      if (error.response) {
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
      }
    }
  };
  const getUser = async () => {
    setLoading(true);
    try {
      const response = await Axios.post(apiRoutes[environment].getprofile, {
        id: props.user.id,
      });
      console.log(response.data.hotels);
      if (response.status == 200) {
        setUser(response.data);
        setHotels(response.data.hotels);
      }
    } catch (error) {
      if (error.response) {
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
        message.error({
          content: "Sorry, there was an error. " + error.response.data.message,
          className: "messageBox",
        });
      }
    }
    setLoading(false);
  };
  const onFinish = async (values) => {
    var term = new Date().getFullYear();
    var dataValue = values;
    dataValue._id = currentNomination._id;
    dataValue.term = term;

    console.log(values);
    submitInfo(dataValue);
    var message = "Success! We've received your payment!";
  };

  const submitInfo = async (value) => {
    try {
      const response = await Axios.post(
        apiRoutes[environment].adminUpdateNomination,
        value,
      );
      console.log(response);
      if (response.status == 200) {
        openNotification();
        // navigate("/admin/nominations");
      }
    } catch (error) {
      if (error.response) {
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
        message.error({
          content: "Sorry, there was an error. " + error.response.data.message,
          className: "messageBox",
        });
      }
    }
    setTimeout(() => {
      setLoading(false);
    }, 3000);
  };
  function onChange(e) {
    var hotelId = e.target.value;
    var hotelSelected = hotels.find((item) => item._id == hotelId);

    setSelectedHotel(hotelSelected);
    form.setFieldsValue({ category: "" });
    console.log(`radio checked:${e.target.value}`);
  }
  function handleChange(value) {
    console.log(`selected ${value}`);
  }
  const hotelRadioGroup = () => {
    var term = new Date().getFullYear();

    var options = "";

    if (hotels) {
      options = hotels.map((hotel) => {
        var isDisabled = false;
        // if (!hotel) {
        //   return;
        // }
        // var hotelNominations = hotel.nominations;
        // if (hotel.nominations) {
        //   isDisabled =
        //     hotelNominations.filter((item) => item.term == term).length >= 4;
        // }

        return (
          <Option key={hotel._id} value={hotel._id} disabled={isDisabled}>
            {hotel.name}
          </Option>
        );
      });
    }

    return (
      <Select
        showSearch
        style={{
          width: 200,
        }}
        placeholder="Search to Select"
        optionFilterProp="children"
        filterOption={(input, option) =>
          option.children && option.children.includes(input)
        }
        filterSort={(optionA, optionB) =>
          optionA.children &&
          optionA.children
            .toLowerCase()
            .localeCompare(optionB.children.toLowerCase())
        }
      >
        {options}
      </Select>
    );
    // if (hotels) {
    //   return hotels.map((hotel) => {
    //     var isDisabled = false;
    //     if (!hotel) {
    //       return;
    //     }
    //     var hotelNominations = hotel.nominations;
    //     if (hotel.nominations) {
    //       isDisabled =
    //         hotelNominations.filter((item) => item.term == term).length >= 4;
    //     }

    //     return (
    //       <Radio.Button key={hotel._id} value={hotel._id} disabled={isDisabled}>
    //         {hotel.name}
    //       </Radio.Button>
    //     );
    //   });
    // }
  };
  const userOptions = () => {
    return users.map((user) => {
      return (
        <Option key={user._id} value={user._id}>
          {user.firstName} {user.lastName}
        </Option>
      );
    });
  };

  const cateogryOptions = () => {
    var term = new Date().getFullYear();
    return categories.map((category) => {
      var isDisabled = false;
      // var hotelNominations = selectedHotel.nominations;

      if (selectedHotel && selectedHotel.nominations) {
        var allNominationsByTerm = selectedHotel.nominations.filter(
          (item) => item.term == term,
        );
        var allNominationsCategories = allNominationsByTerm.map(
          (item) => item.category,
        );

        if (!allNominationsCategories.includes(category)) {
          isDisabled = false;
        } else {
          if (
            category == currentNomination.category &&
            !currentNomination.hotel
          ) {
            isDisabled = true;
          }
          if (
            allNominationsCategories.includes(category) &&
            category != currentNomination.category
          ) {
            isDisabled = true;
          }
        }

        // isDisabled =
        //   allNominationsCategories.includes(category) &&
        //   category != currentNomination.category;

        // isDisabled =
        //   category == currentNomination.category && !currentNomination.hotel;
      }

      return (
        <Option value={category} key={category} disabled={isDisabled}>
          {category}
        </Option>
      );
    });
  };

  const showQuestions = () => {
    return questions.map((question, index) => {
      return (
        <Row gutter={gutterLayout} key={"q" + (index + 1)}>
          <Col span={24}>
            <Form.Item name={["q" + (index + 1), "answer"]} label={question}>
              <TextArea autoSize={{ minRows: 3 }} />
            </Form.Item>
          </Col>
        </Row>
      );
    });
  };
  const openNotification = (message) => {
    notification.success({
      message: `Success!`,
      description: "Your nomination has been successfully updated! ",
      placement: "top",
    });
  };

  const footer = () => {
    if (state && state.nominations) {
      const nominations = state.nominations;
      const total = nominations.length;
      const index = nominations.findIndex((item) => item == nominationId);

      return (
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <Button disabled={index <= 0}>
            <Link
              to={`/admin/nomination/${nominations[index - 1]}/edit`}
              state={{ ...state, nominations }}
            >
              Previous
            </Link>
          </Button>
          <div>
            <Text>
              {index > -1 ? index + 1 : "-"} / {total}
            </Text>
          </div>
          <Button disabled={index == -1 || index == total - 1}>
            <Link
              to={`/admin/nomination/${nominations[index + 1]}/edit`}
              state={{ ...state, nominations }}
            >
              Next
            </Link>
          </Button>
        </div>
      );
    }

    const navigationState =
      state && state.nominationNavigation
        ? { nominationNavigation: state.nominationNavigation }
        : {};

    return (
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <Button disabled={!nominationNavigation.previousId}>
          <Link
            to={`/admin/nomination/${nominationNavigation.previousId}/edit`}
            state={navigationState}
          >
            Previous
          </Link>
        </Button>
        <div>
          <Text>
            {nominationNavigation.index > -1
              ? nominationNavigation.index + 1
              : "-"}{" "}
            / {nominationNavigation.total || 0}
          </Text>
        </div>
        <Button disabled={!nominationNavigation.nextId}>
          <Link
            to={`/admin/nomination/${nominationNavigation.nextId}/edit`}
            state={navigationState}
          >
            Next
          </Link>
        </Button>
      </div>
    );
  };
  return (
    <div style={{ width: "600px" }}>
      <>
        <Button onClick={() => navigate(-1)}>
          <ArrowLeftOutlined />
          go back
        </Button>
      </>
      <LoadingFrame loading={loading}>
        <Form
          form={form}
          {...layout}
          name="nest-messages"
          layout="vertical"
          onFinish={onFinish}
          validateMessages={validateMessages}
          initialValues={{}}
        >
          <Row gutter={gutterLayout}>
            <Col span={24}>
              <Form.Item name="user" label="Nominator">
                <Select showSearch optionFilterProp="children">
                  {userOptions()}
                </Select>
              </Form.Item>
            </Col>

            <Col xs={24} md={24}>
              <Form.Item
                name={"hotel"}
                label="Hotel"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                {hotelRadioGroup()}
                {/* <Radio.Group onChange={onChange}>
        
                </Radio.Group> */}
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={gutterLayout}>
            <Col xs={24} md={24}>
              <Form.Item
                name={"category"}
                label="Category"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Select
                  style={{ width: 400 }}
                  onChange={handleChange}
                  showSearch
                >
                  {cateogryOptions()}
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={gutterLayout}>
            <Col span={12}>
              <Form.Item
                name={"firstName"}
                label="First Name"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name={"lastName"}
                label="Last Name"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={gutterLayout}>
            <Col span={24}>
              <Form.Item
                name={"title"}
                label="Position"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
          </Row>

          {showQuestions()}

          <Row gutter={gutterLayout}>
            <Col span={24}>
              <Form.Item>
                <Button
                  type="primary"
                  disabled={loading ? true : false}
                  htmlType="submit"
                  block
                >
                  Confirm
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>

        {footer()}
      </LoadingFrame>
    </div>
  );
}
